<template>
    <v-row>
        <v-col cols="12" v-if="!isHomeView">
            <div class="title-section">
                Rendiciones de gastos
            </div>
        </v-col>
        <v-col cols="8">
            <v-btn v-if="isHomeView" class="normal-btn" color="primary" depressed @click="showCreateDialog">
                <v-icon left>mdi-plus-circle-outline</v-icon>
                New Expense Report
            </v-btn>
        </v-col>
        <v-col cols="4">
            <kimsa-text-field placeholder="Buscar" append-icon="mdi-magnify" outlined dense solo flat
                @change="search = $event" />
        </v-col>
        <v-col cols="12">
            <v-data-table class="mt-5" :headers="headers" :loading="loading" :items="reports" :search.sync="search"
                :items-per-page="5">
                <template v-slot:item.actions="{ item }">
                    <v-btn class="mr-1 my-1" fab outlined x-small
                        @click.stop="addItem(item)">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn class="mr-1 my-1" fab outlined x-small
                        @click.stop="editItem(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn v-if="isAdmin" class="mr-1 my-1" fab outlined x-small
                        @click.stop="deleteItem(item)">
                        <v-icon color="primary">mdi-delete</v-icon>
                    </v-btn>
                    <v-btn class="mr-1 my-1" fab outlined x-small
                        @click.stop="pdfItem(item)" :loading="item.loadingPdf">
                        <v-icon>mdi-download</v-icon>
                    </v-btn>
                    <v-btn class="mr-1 my-1" fab outlined x-small
                        @click.stop="goToItem(item)">
                        <v-icon>mdi-arrow-right</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-col>

        <v-col cols="12" class="explain-text">
            In this section you can create; modify, add more expenses to prior reports and generate the pdf file (including images of the receipts).
            <br><br>
            En esta sección podrá crear, modificar, agregar nuevos gastos a reportes anteriores y generar el archivo pdf. (incluyendo imágenes de los Recibos correspondientes).
            <br><br>
            Once you've created your expense report, you can use the (+) sign to enter the list and details of each expense, as well as upload the corresponding receipt. You can enter them all at once or return later and select the (+) sign to enter more expenses in the same report.
            <br>
            <b>Note:</b> Make sure you have the receipt images in digital format so you can select and upload them, associating them with each expense.
            <br><br>
            Una vez creada su rendición de gastos; con el signo (+) podrá ingresar el listado y detalle de cada gasto así como subir su recibo correspondiente. Puede ingresarlos todos en forma inmediata o volver en forma posterior y volver a seleccionar el signo (+) para ingresar mas gastos en la misma rendición.
            <br>
            <b>Nota:</b> preocúpese de tener las imágenes de los recibos ya en formato digital para poder seleccionarlos y subirlos asociándolos a cada gasto.
        </v-col>

        <create-expense-report-dialog @success="loadExpenseReports" ref="creator" />
        <create-expense-item-dialog ref="itemCreator" />

        <kimsa-confirm title="Eliminar" content="¿Esta seguro que desea eliminar esta rendición de gastos?" persistent
            @confirm="onConfirmDelete" @cancel="currentId = null" :loading="loadingDelete" no-close-on-confirm
            ref="confirm" />
    </v-row>
</template>

<script>
import Axios from "@/utils/Axios";
import KimsaTextField from '../common/inputs/KimsaTextField.vue'
import KimsaConfirm from '../common/KimsaConfirm.vue';
import CreateExpenseReportDialog from '../common/expenseReport/CreateExpenseReportDialog.vue';
import CreateExpenseItemDialog from '../common/expenseReport/CreateExpenseItemDialog.vue';
export default {
    components: { KimsaTextField, KimsaConfirm, CreateExpenseReportDialog, CreateExpenseItemDialog },
    name: 'ListExpenseReports',
    props: {
        userId: {
            type: [String, Number],
            default: null,
        },
        isHomeView: {
            type: Boolean,
            default: false,
        },
        clientId: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            search: '',
            loading: false,
            reports: [],
            currentId: null,
            loadingDelete: false,
            headers: [
                { text: 'Expense Report', value: 'code', class: 'grey white--text' },
                { text: 'Description', value: 'description', class: 'grey white--text' },
                { text: 'Exchange rate', value: 'exchange_rate', class: 'grey white--text' },
                { text: '', value: 'actions', sortable: false, class: 'grey' },
            ],
        }
    },
    computed: {
        uniqueExpenseReportRoute() {
            return this.$route.name === 'expense_reports.users.detail' 
        }
    },
    async mounted() {
        const vm = this
        await vm.loadExpenseReports()
    },
    methods: {
        async loadExpenseReports() {
            const vm = this;
            if (!vm.userId) return;
            vm.loading = true

            let payload = {}
            if (vm.isAdmin && !vm.uniqueExpenseReportRoute && vm.clientId) {
                payload.client_id = vm.clientId
            }

            await Axios.post(`expense-reports/users/${vm.userId}/list`, payload).then(res => {
                // console.log('res loadExpenseReports', res)
                vm.reports = res.data.result.expenseReports.map(report => {
                    return {
                        ...report,
                        loadingPdf: false,
                        created_at: vm.$moment(report.created_at).format('DD-MM-YYYY'),
                        updated_at: vm.$moment(report.updated_at).format('DD-MM-YYYY'),
                    }
                })
                // console.log('vm.reports', vm.reports)
            }).catch(er => {
                console.log('error loadExpenseReports', er)
            }).finally(() => {
                vm.loading = false
            })
        },
        showCreateDialog() {
            const vm = this
            vm.$refs.creator.show(vm.clientId)
        },
        editItem(item) {
            const vm = this
            vm.$refs.creator.loadExpenseReport(item.id)
        },
        deleteItem(item) {
            const vm = this
            vm.$refs.confirm.show()
            vm.currentId = item.id
        },
        async onConfirmDelete() {
            const vm = this
            vm.loadingDelete = true

            await Axios.delete(`expense-reports/${vm.currentId}/delete`).then(res => {
                // console.log('res onConfirmDelete',res)
                vm.toast('Rendición de gastos eliminada')
            }).catch(er => {
                console.log('er', er)
                vm.toast('error onConfirmDelete', er)
            })

            vm.loadingDelete = false
            vm.currentId = null

            vm.$refs.confirm.hide()
            await vm.loadExpenseReports()
        },
        addItem(item) {
            const vm = this
            vm.$refs.itemCreator.show(item.id, item)
        },
        async pdfItem(item) {
            const vm = this
            item.loadingPdf = true

            let url = `expense-reports/${item.id}/pdf`

            await Axios.get(url).then(res => {
                console.log('res pdfItem', res)
                const pdf = res.data.result.pdf
                const linkSource = `data:application/pdf;base64,${pdf}`;
                const downloadLink = document.createElement("a");
                const fileName = `${item.code}.pdf`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            }).catch(er => {
                console.log('er', er)
                vm.toast(`error downloadPDF: ${er}`, 'error')
            }).finally(() => {
                item.loadingPdf = false
            })
        },
        goToItem(item) {
            const vm = this
            vm.$router.push({ name: 'expense_reports.details', params: { id: item.id } })
        },
    },
    watch: {
        userId() {
            this.loadExpenseReports()
        },
        clientId() {
            this.loadExpenseReports()
        }
    }
}
</script>

<style scoped>
.title-section {
    color: var(--v-primary-base);
}
</style>